module.exports = __webpack_public_path__ + "static/media/rebookWhiteHook.505077c1.svg";